import { helper as buildHelper } from '@ember/component/helper';
import { convertSecondsToMinutes } from '@dashboard/junk-drawer/utils/time';
export function secondsToMinutes([str]) {
  const seconds = Number(str);
  // eslint-disable-next-line unicorn/prefer-number-properties -- TODO: try switching to Number.isNaN
  if (isNaN(seconds)) {
    return str;
  }
  return convertSecondsToMinutes(seconds);
}
export default buildHelper(secondsToMinutes);